document.addEventListener('DOMContentLoaded', () => {
  const navSection = document.querySelector('.navigation-scroll-to-content');
  const banner = document.querySelector('.nav-visible-section');
  const header = document.querySelector('.oxy-header-wrapper');
  const FIXED_HEADER_HEIGHT = header.offsetHeight;

  if (!navSection) return;

  const showNav = () => navSection.classList.add('is-visible');
  const hideNav = () => {
    navSection.classList.remove('is-visible');
    navSection
      .querySelectorAll('.ct-link-text')
      .forEach((link) => link.classList.remove('active'));
  };

  const handleVisibility = () => {
    if (!banner) {
      showNav();
      return;
    }

    const scrollY = window.scrollY;
    const bannerBottom = banner.offsetTop + banner.offsetHeight;

    scrollY >= bannerBottom - FIXED_HEADER_HEIGHT ? showNav() : hideNav();
  };

  window.addEventListener('scroll', handleVisibility);
  window.addEventListener('load', handleVisibility);
  handleVisibility();
});
